import React from 'react'

const Copyright = () => {
  return (
    <footer className="text-center text-[14px]  mt-8 py-5">
        Copyright © 2025 Novelio Technologies Pvt. Ltd. 
    </footer>
  )
}

export default Copyright